/**
 * 空き家管理サービス
 */
const initPlanTabs = () => {
    document.querySelectorAll('.js-plan-tabs').forEach((root) => {
        const tabs = root.querySelectorAll('[role="tab"]');
        const panels = root.querySelectorAll('[role="tabpanel"]');

        const select = (tab) => {
            tabs.forEach((t) => {
                const isSelected = t === tab;
                t.setAttribute('aria-selected', isSelected ? 'true' : 'false');
                t.tabIndex = isSelected ? 0 : -1;
            });
            panels.forEach((panel) => {
                panel.hidden = panel.id !== tab.getAttribute('aria-controls');
            });
        };

        tabs.forEach((tab, index) => {
            tab.addEventListener('click', () => select(tab));
            tab.addEventListener('keydown', (e) => {
                const targets = {
                    ArrowRight: tabs[(index + 1) % tabs.length],
                    ArrowLeft: tabs[(index + tabs.length - 1) % tabs.length],
                    Home: tabs[0],
                    End: tabs[tabs.length - 1],
                };
                const next = targets[e.key];
                if (!next) return;
                e.preventDefault();
                next.focus();
                select(next);
            });
        });
    });
};

const initScrollIndicators = () => {
    document.querySelectorAll('.js-scroll-indicator').forEach((indicator) => {
        const target = indicator.previousElementSibling;
        const thumb = indicator.querySelector('.js-scroll-indicator-thumb');
        if (!target || !target.classList.contains('js-scroll-indicator-target') || !thumb) return;

        const update = () => {
            const maxScroll = target.scrollWidth - target.clientWidth;
            const maxMove = indicator.clientWidth - thumb.offsetWidth;
            const ratio = maxScroll > 0 ? target.scrollLeft / maxScroll : 0;
            thumb.style.transform = `translateX(${ratio * maxMove}px)`;
        };

        target.addEventListener('scroll', update, { passive: true });
        window.addEventListener('resize', update);
        update();
    });
};

const akiyaKanriPage = () => {
    if (document.body.id !== 'page-akiya-kanri') return;

    initPlanTabs();
    initScrollIndicators();
};

export default akiyaKanriPage;
